import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { GlobalLoading } from "../Utils";

const DevelopersHome = lazy(() => import("../Components/ProfilesType/Developers/DevelopersHome/DevelopersHome"));
const Notifications = lazy(() => import("../Components/ProfilesType/Developers/Notifications/Notifications"));
const MailNotification = lazy(() => import("../Components/ProfilesType/Developers/Notifications/MailNotification/MailNotification"));
const WhatsAppNotification = lazy(() => import("../Components/ProfilesType/Developers/Notifications/WhatsAppNotification/WhatsAppNotification"));

export const developerRoutes = [
    {
        index: true,
        element: <Suspense fallback={<GlobalLoading />}><DevelopersHome /></Suspense>,
    },
    {
        path: "notifications",
        element: <Suspense fallback={<GlobalLoading />}><Notifications /></Suspense>,
        children: [
            {
                index: true,
                element: <Navigate to="mail" replace />,
            },
            {
                path: "mail",
                element: <Suspense fallback={<GlobalLoading />}><MailNotification /></Suspense>,
            },
            {
                path: "whatsapp",
                element: <Suspense fallback={<GlobalLoading />}><WhatsAppNotification /></Suspense>,
            },
        ],
    },
]
